//导入刚才写好的axios二次封装的requests
import request from "./request";
//三级联动接口
///api/product/getBaseCategoryList get 无参数
//发请求：axios发请求返回结果promise对象

//新闻查询列表
export function newsList(data,pageNum,pageSize) {

  return request({
    url: '/admin/news/list',
    method: 'post',
    data: data,
    headers: { pageNum: pageNum, pageSize: pageSize }
  })
}
//查询
export function newsView(data) {
  return request({
    url: '/admin/news/view',
    method: 'post',
    data
  })
}

export function HgAssociationTrain_add(data) {
  return request({
    url: '/HgAssociationTrain/add',
    method: 'post',
    data
  })
}

export function EmployingDemand_list(data,pageNum,pageSize) {

  return request({
    url: '/EmployingDemand/list',
    method: 'post',
    data: data,
    headers: { pageNum: pageNum, pageSize: pageSize }
  })
}

export function unitList(data, pageNum, pageSize) {
  return request({
    url: 'hgassoc/unitList',
    method: 'post',
    data:{
      ...data,
      page: pageNum,
      limit: pageSize
    },
    headers: { pageNum: pageNum, pageSize: pageSize }
  })
}

